<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7">
          Propagace
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-7">
          <v-row v-if="logoUrlBase64" class="">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="2" class="py-0">
                  <div class="request-label">Logo</div>
                  <div class="request-value mt-2">
                    <v-img :src="logoUrlBase64" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID</div>
                  <div class="request-value mt-2">
                    {{ promotion.id }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">UUID</div>
                  <div class="request-value mt-2">
                    {{ promotion.uuid }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název</div>
                  <div class="request-value mt-2">
                    {{ promotion.name ? promotion.name : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Popis</div>
                  <div class="request-value mt-2">
                    {{ promotion.description ? promotion.description : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název akčního tlačítka</div>
                  <div class="request-value mt-2">
                    {{ promotion.btnActionName ? promotion.btnActionName : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="promotion.gift">
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">ID dárku</div>
                  <div class="request-value mt-2">
                    <router-link
                      :to="{
                        name: 'gifts.detail',
                        params: {
                          giftId: promotion.gift.id,
                        },
                      }"
                    >
                      {{ promotion.gift ? promotion.gift.id : '-' }}
                    </router-link>
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Název dárku</div>
                  <div class="request-value mt-2">
                    {{ promotion.gift ? promotion.gift.name : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Typ formuláře</div>
                  <div class="request-value mt-2">
                    {{ promotion.formType ? promotion.formType.text : '-' }}
                  </div>
                </v-col>
                <v-col v-if="promotion.sources.length" cols="4" class="py-0">
                  <div class="request-label">Zdroje</div>
                  <div
                    v-for="item in promotion.sources"
                    :key="item.name"
                    class="request-value mt-2"
                  >
                    {{ item.text }}
                  </div>
                </v-col>
                <v-col v-else cols="4" class="py-0">
                  <div class="request-label">Zdroje</div>
                  <div class="request-value mt-2">-</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Začátek</div>
                  <div class="request-value mt-2">
                    {{ promotion.startAt ? $dayjs(promotion.startAt).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
                <v-col cols="4" class="py-0">
                  <div class="request-label">Ukončení</div>
                  <div class="request-value mt-2">
                    {{ promotion.endAt ? $dayjs(promotion.endAt).format('D.M.YYYY') : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Zobrazení po</div>
                  <div class="request-value mt-2">
                    {{ promotion.showIn ? promotion.showIn + ' s' : '-' }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row class="pb-6">
                <v-col cols="4" class="py-0">
                  <div class="request-label">Stav</div>
                  <div class="request-value mt-2">
                    <EnabledDisabled v-if="promotion" :value="promotion.enabled" />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <template>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :to="{ name: 'promotions.edit', params: { promotionId: promotion.id } }"
            >
              Editovat
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EnabledDisabled from '../../../components/EnabledDisabled'
import arrayBufferToBase64 from '../../../utils/resource'

export default {
  name: 'PromotionDetail',
  components: { EnabledDisabled },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      promotion: {
        logo: null,
      },
      logoBase64: null,
      loading: false,
      saving: false,
    }
  },
  computed: {
    logoUrlBase64() {
      if (this.logoBase64) {
        return `data:image/png;base64,${this.logoBase64}`
      }
      return null
    },
  },
  created() {
    this.loadPromotion()
  },
  methods: {
    ...mapActions({
      getPromotion: 'promotion/getPromotion',
      getArrayBuffer: 'upload/getArrayBuffer',
    }),
    loadPromotion() {
      this.loading = true
      this.getPromotion(this.$route.params.promotionId)
        .then((response) => {
          this.promotion = response.data
          this.loadPromotionLogo(this.promotion.logo.uuid)
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadPromotionLogo(uuid) {
      this.loading = true
      this.getArrayBuffer(uuid)
        .then((response) => {
          this.logoBase64 = arrayBufferToBase64(response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.push({
        name: 'promotions',
      })
    },
  },
}
</script>
